import React from "react";
import Fleets from '../../../Features/Tables/FleetRoutes'

const All = () => {
  return <div>
    <Fleets />
  </div>;
};

export default All;
